import { useContext } from 'react';
import { AxonAccountContext } from '../../contexts/axon_account';
/**
 * Only safe below `SitesWrapper`, which gates its `<Outlet />` on a loaded account. Anything rendered above
 * that gate — or while the account query refetches, such as during a time-travel lane switch — must read
 * `AxonAccountContext` directly and tolerate a null account instead of using this hook.
 */
export const useAxonAccountContext = () => {
    const { account } = useContext(AxonAccountContext);
    if (!account) {
        throw new Error('useAxonAccountContext should be used within AxonAccountContext');
    }
    return account;
};
